// extracted by mini-css-extract-plugin
module.exports = {"icon":"_10421"};